import { useWindowSize } from '@react-hookz/web'

export const useIsMobile = () => {
    const windowSize = useWindowSize()
  
    const isMobile = windowSize.width < 768
  
    return { isMobile }
  };